import Application from "../Application";
import Area, { IArea } from "./Area";
import { IRouter } from "../runtime/Router";
import EmptyPage from "../ui/pages/EmptyPage";
import { Layouts } from "../common/Constants";
import PortalHomePage from "../ui/pages/main/PortalHomePage";
import ShowPortalHomeInteractor from "../interactor/main/ShowPortalHomeInteractor";

export default class MikPortalArea extends Area implements IArea {
  private application: Application;
  private router: IRouter;

  constructor(application: Application, router: IRouter) {
    super();
    this.application = application;
    this.router = router;
  }

  register(params: any) {
    this.router.registerRoutes(
      {
        path: "/home",
        page: this.createPage({
          Page: PortalHomePage,
          action: this.showPortalHomePage.bind(this)
        }),
        options: {
          secure: false
        }
      },
      {
        path: "/",
        page: this.createPage({
          Page: PortalHomePage,
          action: this.showPortalHomePage.bind(this)
        }),
        options: {
          secure: false
        }
      },
      {
        path: "/error",
        page: this.createPage({
          Page: EmptyPage,
          action: () => {}
        }),
        options: {
          secure: false,
          initialProps: {
            title: "Error",
            text: "page not found."
          },
          layout: Layouts.BASE
        }
      }
    );
  }

  public showPortalHomePage() {
    return this.application.container
      .resolve<ShowPortalHomeInteractor>("showPortalHome")
      .execute();
  }
}
